/**
 * Mirrors `/api/meta/status-palette` — fetched once on app boot and
 * cached. Components import `useStatusPalette()` and get a stable map
 * of status → { label, bg_class, text_class, border_class, group, ... }.
 *
 * This is the single source of truth for talent×shift status colors
 * across Admin Dashboard, Attendance Panel, Calendar, Shift Detail,
 * Talent Schedule, and Reports — guaranteed to match what the backend
 * emits.
 */
import { useEffect, useState } from 'react';
import api from './api';

let _cache = null;
let _inflight = null;

export const fetchStatusPalette = async () => {
  if (_cache) return _cache;
  if (!_inflight) {
    _inflight = api.get('/meta/status-palette').then((r) => {
      _cache = r.data;
      return _cache;
    }).catch(() => null);
  }
  return _inflight;
};

export const useStatusPalette = () => {
  const [palette, setPalette] = useState(_cache);
  useEffect(() => {
    if (!_cache) fetchStatusPalette().then(setPalette);
  }, []);
  return palette;
};

/** Lookup helper — returns palette entry with safe fallback. */
export const getStatusEntry = (palette, key) => {
  if (!palette || !key) {
    return { label: key || '—', bg_class: 'bg-gray-100', text_class: 'text-gray-800', border_class: 'border-gray-300', group: 'pre_event', color_hex: '#9ca3af' };
  }
  return palette.statuses?.[key] || {
    label: String(key).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    bg_class: 'bg-gray-100', text_class: 'text-gray-800', border_class: 'border-gray-300',
    group: 'pre_event', color_hex: '#9ca3af',
  };
};
